import { ActuatorBaseDto, ActuatorDataDto, SmarthomeConfiguredDto } from '../../dto/smart-home.dto'
import { Actuator, ActuatorData, ActuatorDescriptions } from '../../models/smart-home.model'

export const smarthomeConfiguredDtoToModelTransformer = (dto: SmarthomeConfiguredDto): boolean => dto.configured

export const actuatorDataDtoToModelTransformer = (dto: ActuatorDataDto[]): ActuatorData[] => {
  return dto.map(d => {
    return {
      ...d,
      actors: d.actors.map(actuatorDtoToModelTransformer),
    }
  })
}

export const actuatorDtoToModelTransformer = (dto: ActuatorBaseDto): Actuator => {
  const { descriptions, ...actuatorBase } = dto

  const descriptionsTransformed: ActuatorDescriptions = {
    s10: descriptions.S10,
    single: descriptions.SINGLE,
    group: descriptions.GROUP,
    timeOn: descriptions.TimeOn,
    timeOff: descriptions.TimeOff,
    socOn: descriptions.SOCOn,
    socOff: descriptions.SOCOff,
    minOn: descriptions.minOn?.toString().padStart(5, '0'),
    minOff: descriptions.minOff?.toString().padStart(5, '0'),
    usedPower: typeof descriptions.usedPower === 'string' ? Number.parseInt(descriptions.usedPower) : descriptions.usedPower,
    refSource: descriptions.refSource,
    refPM: descriptions.refPM,
    refTH: descriptions.refTH,
    refMax: descriptions.refMax,
    refStart: descriptions.refStart,
    week: descriptions.Week,
    auto: descriptions.Auto === '1',
  }

  const result = {
    ...actuatorBase,
    descriptions: Object.fromEntries(Object.entries(descriptionsTransformed).filter(([_, value]) => value !== undefined)) as ActuatorDescriptions,
  }

  return result
}
